/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-05-26 17:04:41
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-07-07 16:40:09
 * @FilePath: \crm-product\src\views\performanceCalculation\views\import_statement\product_price\form\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Form, {
  formCreate,
} from '@/found/components/form';
import request from '@/found/utils/request';
import productList from './product_list.vue';

formCreate.component('productList', productList);

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {

    };
  },
  async created() {
    await this.getFormRule('main-form');
  },
  methods: {
    // 设置规则
    setRule(item) {
      const v = item;
      if (v.field === 'productName') {
        v.props = {
          ...v.props,
          params: {
            functionCode: 'choose-product-list',
            paramData: {
              enableStatus: '009',
            },
          },
          title: '选择产品',
        };
        v.on = {
          ...v.on,
          change: (e) => {
            if (e && e.length) {
              const objProduct = e[0];
              this.setValue({
                productCode: objProduct.materialCode,
                productName: objProduct.materialName,
                productSeriesName: objProduct.productLevelName,
                productSeriesCode: objProduct.productLevelCode,
                productSpec: objProduct.specification,
                productUnit: objProduct.unitConversion,
              });
            }
          },
        };
      }
      if (v.field === 'productPrice') {
        v.props = {
          ...v.props,
          min: 0,
          precision: 2,
        };
      }
      if (v.field === 'effectiveStartDate' || v.field === 'effectiveEndDate') {
        v.props = {
          ...v.props,
          type: 'datetime',
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
          'default-time': v.field.toLowerCase().includes('end')
            ? '23:59:59'
            : '00:00:00',
          relation: {
            beginField: 'effectiveStartDate',
            endField: 'effectiveEndDate',
          },
        };
      }
      if (v.field === 'priceBand') {
        v.on = {
          ...v.on,
          change: (e) => {
            if (e) {
              this.setValue({
                priceBandCoefficient: e,
              });
            } else {
              this.setValue({
                priceBandCoefficient: '',
              });
            }
          },
        };
      }
      if (v.field === 'promotionOrgCode') {
        v.on = {
          ...v.on,
          getItem: (e) => {
            this.setValue({
              promotionOrgName: e.dictValue,
            });
          },
        };
      }
      return v;
    },
    // 渲染完成后执行
    formComplete() {
      const {
        code,
      } = this.formConfig;
      if (code === 'view' || code === 'edit') {
        request.post('/mdm/performanceproductprice/query', {
          id: this.formConfig.row.id,
        }).then((res) => {
          if (res.success) {
            const {
              result,
            } = res;
            this.setValue({
              ...result,
            });
          }
        });
      }
    },
    submit() {
      const formData = this.getFormData(); // 获取表单的值
      if (formData) {
        let url = '/mdm/performanceproductprice/save';
        const params = {
          ...formData,
        };
        if (this.formConfig.code === 'edit') {
          url = '/mdm/performanceproductprice/update';
          params.id = this.formConfig.row.id;
        }
        request.post(url, params).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.$emit('onClose');
            this.$emit('onGetList');
          }
        });
      }
    },
  },
};
